import OAuthService from "services/oauth-service";
import SearchService from "services/search-service";
import DownloadService from "services/download-service";
import UserService from "services/user-service";

/**
 * Facebook Login Handler for Instagram (uses short-lived token, no Page access token generation)
 */
export const instagramLoginHandler = (resolve, reject) => {

  if (!window.FB) {
    console.error("Facebook SDK not loaded");
    reject(new Error("Facebook SDK not loaded"));
    return;
  }

  window.FB.login(
    (response) => {
      if (response.authResponse) {
        console.log("Logged in with Facebook:", response);
        checkLoginStateForInstagram(resolve, reject);
      } else {
        console.log("User cancelled login or did not fully authorize.");
        reject(new Error("Login cancelled or not authorized."));
      }
    },
    {
      scope: [
        "public_profile",
        "email",
        "pages_show_list",
        "pages_read_engagement",
        "instagram_basic",
        "instagram_manage_insights",
      ].join(","),
    }
  );
};

/**
 * After login, get the login status and proceed.
 */
const checkLoginStateForInstagram = (resolve, reject) => {
  window.FB.getLoginStatus(async (response) => {
    try {
      await statusChangeCallbackForInstagram(response);
      resolve();
    } catch (error) {
      reject(error);
    }
  });
};

/**
 * Handles login response and fetches Instagram account data via Graph API
 */
const statusChangeCallbackForInstagram = async (response) => {
  console.log("Instagram Login response status: ", response.status);

  if (response.status !== "connected") {
    console.warn("User not authenticated (status not 'connected').");
    throw new Error("Facebook login failed or was cancelled.");
  }
  console.log("Instagram Login response : ", response);
  const fbSLAT = response.authResponse.accessToken;

  localStorage.setItem("fbSLAT", fbSLAT);
  console.log("Instagram Short-Lived Access Token:", fbSLAT);

  const searchTerm = "Dummy"; // Example search term
  const platform = "Instagram";
  const combinedResults = await SearchService.searchAllPlatforms(searchTerm, platform);
  console.log("Search Results Length:", combinedResults ? combinedResults.length : "null");

  if (combinedResults && combinedResults.length > 0) {
    for (const result of combinedResults) {
      try {

        const profileData = {
          id: result.id,
          platform: result.platform,
          name: result.name,
          count: result.followers_count || result.subscribersCount,
          media_count: result.media_count,
          profilePictureUrl: result.profile_picture_url,
          link: result.link,
          own: true,
        };

        console.log("Prepared Profile Data : ", profileData);

        // Download profile using the DownloadService
        await DownloadService.downloadProfile(result.platform, { profileData });
        console.log(`Successfully downloaded profile: ${result.name}`);
        localStorage.removeItem("fbSLAT");
      } catch (error) {
        console.error(`Error downloading profile (${result.name}):`, error.message);
      }
    }
  } else {
    // Clean up token to avoid interfering with other requests
    localStorage.removeItem("fbSLAT");
    console.warn("⚠️ No Instagram profiles found.");
    throw new Error("No Instagram business profiles found connected to this Facebook account.");
  }
};








// // Define the scopes required for Instagram (basic profile + media access)
// const SCOPES = "user_profile,user_media";

// export const instagramLoginHandler = async (resolve, reject) => {
//   try {
//     console.log("Initiating Instagram login...");
//     OAuthService.initiateOAuthLogin("instagram");
//     resolve(); // Resolve immediately after the redirect is initiated
//   } catch (error) {
//     console.error("Error during Instagram login:", error.message);
//     reject(error); // Reject the promise if there is an error
//   }
// };
